import NoRecord from "screens/sharedScreens/noRecord/NoRecord";
import CustomTableGrid from "components/uiComponents/CustomTableGrid";
import ReactTable from "components/wrapperComponents/ReactTable";
import { msgTypes } from "constants/msgTypes";
import { Form, Formik } from "formik";
import { CompanyServicesModel } from "model/screensModels/CompanyServicesModel";
import { PaginatorModel } from "model/utilModels/PaginatorModel";
import { ResponseModel } from "model/utilModels/ResponseModel";
import React, { useEffect, useMemo, useState } from "react";
import { CompanyServicesService } from "services/menu/companyServicesService/CompanyServicesService";

import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { conformationAlert } from "services/shared/alert";
import { Box, Switch } from "@mui/material";
import ApiUrl from "services/shared/ApiUrl";
import FormikControl from "components/wrapperComponents/FormikControl";
import Tooltip from '@mui/material/Tooltip';

const CompanyServicesList = ({ setFlag, updateRecord, loadRecentCompanyService }) => {
  const [companyServicesList, setCompanyServicesList] =  useState<ResponseModel | null>(null); 
  const paginatorModel: PaginatorModel = new PaginatorModel();
  const [pagination, setPagination] = useState({
    pageSize: paginatorModel.pageSize,
    pageNumber: paginatorModel.pageNumber,
    filter: "",
    orderBy: "",
    desc: "",
  });


  const updateStatus = async (record: CompanyServicesModel) => {
    record.status = !record.status;
    const updateStatusFlag = await conformationAlert(
      msgTypes.CONFORMATION_MESSAGE.UPDATE_RECORD,
      msgTypes.CONFORMATION_ICON.WARNING,
      "Yes! Update"
    );
    if (updateStatusFlag) {
      const res = await CompanyServicesService.addCompanyServices(record);
      if (res.statusMsg === msgTypes.SUCCESS.msg) {
        getCompanyServicesList();
      }
    }
  };

  const columns = useMemo(() =>
    [
     
      {
        accessorKey: "serviceName",
        header: "Service Name",
        size: 500
      },
      {
        accessorKey: "status",
        header: "Status",
        size: 50,
        Cell: ({ cell, row }) => (
          <Switch
            name="status"
            checked={row?.original?.status}
            onChange={() => {
              updateStatus(row.original)
            }}
          />
        ),
      },
      {
        header: 'Action',
        Cell: ({ renderedCellValue, row }) => (
          <div className='d-flex'>
          {/* <EditIcon onClick={()=>{editRecord(row.original)}} color='primary'/>
          <DeleteIcon onClick={()=>{deleteRecord(row.original)}} color='error' /> */}
          <Tooltip title="Edit">
              <EditIcon fontSize="small" onClick={()=>{editRecord(row.original)}} />
            </Tooltip>
            <Tooltip title="Delete">
              <DeleteIcon fontSize="small" onClick={()=>{deleteRecord(row.original)}} />
            </Tooltip>
          </div>
        ),
        size: 10,
        grow: false,
      },
    ], []);


  useEffect(() => {
    getCompanyServicesList();
  }, [pagination.pageNumber, pagination.pageSize, pagination.filter, pagination.orderBy, pagination.desc])

  //Begin:: UseEffect Hooks

  //Prepare request body to get blog list
  const prepareRequest = () => {
    const requestBody = new PaginatorModel();
    requestBody.pageNumber = pagination.pageNumber;
    requestBody.pageSize = pagination.pageSize;
    requestBody.filter = pagination.filter;
    requestBody.orderBy = pagination.orderBy;
    requestBody.desc = pagination.desc;
    return requestBody;
  };

  // Get Company Services List
  const getCompanyServicesList = async () => {
    const requestBody = prepareRequest();
    const res = await CompanyServicesService.getCompanyServicesList(requestBody);

    if (res.statusMsg === msgTypes.SUCCESS.msg) {
      setCompanyServicesList(res);
    }
  };

  //Open Form To edit Record
  const editRecord = (record: CompanyServicesModel) => {
    updateRecord(record);
    setFlag(true);
  };

  const deleteRecord = async (record: CompanyServicesModel) => {
    const requestData: CompanyServicesModel = new CompanyServicesModel();
    requestData.serviceId = record.serviceId;

    const deleteFlag = await conformationAlert(
      msgTypes.CONFORMATION_MESSAGE.DELETE_RECORD,
      msgTypes.CONFORMATION_ICON.ERROR, "delete"
    );
    if (deleteFlag) {
      const res = await CompanyServicesService.deleteCompanyServices(
        requestData
      );
      if (res.statusMsg === msgTypes.SUCCESS.msg) {
        getCompanyServicesList(); 
        loadRecentCompanyService();
      }
    }
  };

  const initialValues = {};
  const onSubmit = () => {
    getCompanyServicesList();
  };

  return (
    <>
      <Formik
        enableReinitialize={true}
        initialValues={initialValues}
        onSubmit={onSubmit}
      >
        {(formik) => (
          <Form>
              {companyServicesList ? (
            <CustomTableGrid
              item={
                <FormikControl
                  control='materialTable'
                  tableColumn={columns}
                  tableData={companyServicesList}
                 // formikValue={formik}
                  setPagination={setPagination}
                  // actions={[{ type: "icon", icon: <EditIcon />, actionFunc: editRecord },
                  // { type: "icon", icon: <DeleteIcon color='error' />, actionFunc: deleteRecord }
                  // ]}
                />
              }
            />
          ) : null}
          </Form>
        )}
      </Formik>
    </>
  );
};

export default CompanyServicesList;
